<div class="user-listing">
  <div class="scroll-container">
    <div class="overflow-y">
      <ng-container
        *ngFor="
          let user of usersList | async | orderBy : ['firstName', 'lastName'];
          let i = index
        "
      >
        <div class="row py-2 my-2">
          <!-- Profile Picture -->
          <div class="col-md-1 col-sm-2 col-lg-1 col-xl-1 col-2 pl-2">
            <app-profile-picture
              [name]="user?.firstName + ' ' + user.lastName"
              [userData]="user"
            >
            </app-profile-picture>
          </div>
          <div class="heading-padding col-8">
            <div class="col-12 heading">
              <app-with-tooltip [showHelpCursor]="true">
                {{ user?.firstName }} {{ user.lastName }}
              </app-with-tooltip>
            </div>
            <div class="col-12 status mt-2">
              <app-with-tooltip [showHelpCursor]="true">
                {{ user?.userType }}
              </app-with-tooltip>
            </div>
          </div>

          <!-- Invitation Icon Aligned Right -->
          <div
            *ngIf="user?.invitationPending === 'true'"
            class="col-2 d-flex justify-content-end align-items-center"
          >
            <img
              src="assets/svg/invitation-pending.svg"
              class="invitation-pending-icon"
              alt="Invitation Pending"
              title="Invitation Pending"
              style="width: 20px; height: 20px"
            />
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="d-flex align-items-start py-3">
    <div class="grey-user-align pr-4">
      <img
        alt="User Icon"
        src="assets/svg/ico-user-circle.svg"
        class="height-40 width-40"
      />
    </div>
    <div class="add-lock-heading pt-2 mt-1">
      {{ "USER_ADD_USER" | translate }}
    </div>
    <div class="add-icon pt-2 pointer-cursor">
      <img src="assets/svg/ico-add.svg" (click)="addUser()" />
    </div>
  </div>
</div>
